export enum FileExtension {
  JPG,
  PNG,
  MP4
}
